import { ILocaleService } from '@gn-audio/angularjs-components/locale/services/locale-service';
import { IHttpInterceptor, IRequestConfig, IPromise, IHttpResponse } from 'angular';
import { Injectable } from 'angular-ts-decorators';

@Injectable('MarketLocaleInterceptor')
export class MarketLocaleInterceptor implements IHttpInterceptor {
  public static $inject: ReadonlyArray<string> = ['$q', 'localeService'];

  constructor(private readonly $q: ng.IQService, private readonly localeService: ILocaleService) {}

  public request = (config: IRequestConfig): IRequestConfig | IPromise<IRequestConfig> => {
    if (config.url.indexOf('marketLocale=') > -1) {
      return config || this.$q.when(config);
    }

    const isScApiRequest: boolean = config.method === 'GET' && config.url.includes('/public-api');

    if (isScApiRequest && !config.url.startsWith(this.localeService.localePrefix())) {
      const prefix = this.localeService.localePrefix();

      config.url = config.url.startsWith('/') ? `${prefix}${config.url}` : `${prefix}/${config.url}`;
    }

    return config || this.$q.when(config);
  };

  public response = (response: IHttpResponse<any>): IHttpResponse<any> | IPromise<IHttpResponse<any>> => {
    return response || this.$q.when(response);
  };
}
